import React, { useState } from 'react';
import { Form, Input, Checkbox, Button, message,notification } from 'antd';
import axios from 'axios';
import "./App.css"
import Password from 'antd/es/input/Password';
import { useNavigate, useParams,useLocation } from 'react-router-dom';

const SignupForm = () => {
  const [form] = Form.useForm();
  const navigate=useNavigate()
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const invitationToken = searchParams.get('invitationToken');

  const handleSubmit = async (values) => {
    try{
      const url=invitationToken ? `${process.env.REACT_APP_API}/api/auth/signup?invitationToken=${invitationToken}` :`${process.env.REACT_APP_API}/api/auth/signup`
      await axios.post(url,
      {email:values.email,name:values.fullName,password:values.password})
      navigate("/login")
      
    }
    catch(err)
    {
      notification.error({
        message: 'Error',
        description: err.response.data.message,
      });
    }
 
  };


  return (
    <div className="container">
      <h1 className="title">ZautoAI Leading the AI Revolution</h1>
      <p className="subtitle">Join our platform and fall in love with your work!
      </p>
      <Form
        form={form}
        onFinish={handleSubmit}
        className="form"
        layout="vertical"
      >
        <Form.Item
          name="fullName"
          label="Full Name"
          rules={[{ required: true, message: 'Please enter your full name' }]}
        >
          <Input placeholder="Enter your full name" />
        </Form.Item>
        <Form.Item
          name="email"
          label="Email"
          rules={[
            { required: true, message: 'Please enter your email' },
            { type: 'email', message: 'Please enter a valid email' }
          ]}
        >
          <Input placeholder="Enter your email" />
        </Form.Item>
        <Form.Item
          name="password"
          label="Password"
          rules={[
            { required: true, message: 'Please enter your password' },
          ]}
        >
          <Input type='password' placeholder="Enter your password" />
        </Form.Item>
        <Form.Item
          name="confirmPassword"
          label="Confirm Password"
          rules={[
            { required: true, message: 'Please enter your Confirm password' },
          ]}
        >
          <Input type='password' placeholder="Re enter your password" />
        </Form.Item>

        <Form.Item
          name="terms"
          valuePropName="checked"
          rules={[{ required: true, message: 'You must accept the terms' }]}
        >
          <Checkbox >I agree to the Terms & Conditions</Checkbox>
        </Form.Item>
        <Form.Item>
          <Button type="primary" htmlType="submit" className="button">
            Sign up
          </Button>
        </Form.Item>
      </Form>
    </div>
  );
};

export default SignupForm;
